import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/system";
import ParagraphText from "../ParagraphText";
import { Box } from "@material-ui/core";
import { DropDown } from "../../assets/icons/icon";
import "./styles.css";
import { removeAllSpaces } from "../../utils";

const GroupHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "4px 10px",
  color: "var(--FoundationBlueNormal)",
  backgroundColor: "var(--FoundationBlueLightHover)",
  ...theme.applyStyles("dark", {
    backgroundColor: "var(--FoundationBlueLightHover)",
  }),
  fontFamily: '"Outfit", sans-serif !important',
}));

const GroupItems = styled("ul")({
  padding: 0,
  fontFamily: '"Outfit", sans-serif !important',
});

export default function AppAutoCompleteomplete({
  options = [],
  label = "",
  placeholder = "",
  renderKey = "",
  isGroup = false,
  handleSelectOption = () => {},
  popularList = [],
  className = "",
  value,
  required,
  handleLogEvent = () => {},
  logoKey = "",
  postLabelKey = "",
  id = "",
  popoverClass="",
  ...props
}) {
  // Optimized data processing in a single loop
  const optionsList = [];
  const popularOptions = [];

  options.forEach((option) => {
    const firstLetter = option[renderKey][0]?.toUpperCase();
    const categorizedOption = {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };

    if (popularList.includes(option[renderKey])) {
      popularOptions.push({ ...option, firstLetter: "Popular" });
    } else {
      optionsList.push(categorizedOption);
    }
  });

  // Only sort if grouping is enabled
  if (isGroup) {
    optionsList.sort((a, b) => a.firstLetter.localeCompare(b.firstLetter));
  }

  const finalOptions = [...popularOptions, ...optionsList];

  // Get default selected value
  const defaultVal =
    finalOptions.find((item) => item[renderKey] === value) || null;

  return (
    <div className={`AppAutoCompleteWrapper ${className}`}>
      {label && (
        <ParagraphText className="fontSize14 blue800Color textCapitalizeFirstLetter mb-2">
          {label} {required && <span className="foundationErrorRed">*</span>}
        </ParagraphText>
      )}
      <Autocomplete
        onOpen={handleLogEvent}
        value={defaultVal}
        onChange={(event, newValue) => handleSelectOption(newValue)}
        popupIcon={<DropDown width={20} />}
        slotProps={{
          popper: {
            className: popoverClass,
          },
          paper: {
            sx: {
              "& .MuiAutocomplete-listbox": {
                "& .MuiAutocomplete-option": {
                  background: "var(--white)",
                },
              },
            },
          },
        }}
        options={finalOptions}
        groupBy={(option) => (isGroup ? option?.firstLetter : null)}
        getOptionLabel={(option) => option[renderKey]}
        renderInput={(params) => (
          <TextField {...params} placeholder={placeholder} />
        )}
        id={id || ""}
        renderGroup={(params) => (
          <li key={params.key}>
            {isGroup && <GroupHeader>{params.group}</GroupHeader>}
            <GroupItems>{params.children}</GroupItems>
          </li>
        )}
        renderOption={(props, option) => (
          <li {...props} id={removeAllSpaces(`${id}_${option[renderKey]}`)}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                width: "100%",
              }}
            >
              {option[logoKey || "image"] && (
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Box className="bankLogo">
                    <img
                      src={
                        Array.isArray(option[logoKey || "image"])
                          ? option[logoKey || "image"][0]
                          : option[logoKey || "image"]
                      }
                      alt={option[renderKey]}
                    />
                  </Box>
                </Box>
              )}
              {option[renderKey]}
              {Boolean(postLabelKey && option[postLabelKey]) ? (
                <Box className="postLabelStyle">{option[postLabelKey]}</Box>
              ) : (
                ""
              )}
            </div>
          </li>
        )}
        {...props}
      />
    </div>
  );
}
